import { configAxiosContactNetwork, configAxiosContactNetworkBlob } from '@/utils/api-instance';
import { ENDPOINTS } from '@/utils/constants';

export const getContactsNetwork = async queriesStrings => {
    const api = configAxiosContactNetwork();
    const { data } = await api.get(`${ENDPOINTS.ADQUIRED_CONTACTS}${queriesStrings}`);
    return { data };
};

export const getContactsNetworkList = async queriesStrings => {
    const api = configAxiosContactNetwork();
    const { data } = await api.get(`${ENDPOINTS.CONTACT_NETWORK_LIST}${queriesStrings}`);
    return { data };
};

export const getRetrieveContact = async contactId => {
    const api = configAxiosContactNetwork();
    const { data } = await api.get(`${ENDPOINTS.RETRIEVE_ADQUIRED_CONTACT}${contactId}/`);
    return { data };
};

export const getContact = async contactId => {
    const api = configAxiosContactNetwork();
    const { data } = await api.get(`${ENDPOINTS.NETWORK_CONTACTS}${contactId}`);
    return { data };
};

export const setVisualizeQualifiedContact = async payload => {
    const api = configAxiosContactNetwork();
    const { data } = await api.post(ENDPOINTS.QUALIFIED_CONTACT_VISUALIZATION, payload);
    return { data };
};

export const adquireContact = async payload => {
    const api = configAxiosContactNetwork();
    const { data } = await api.post(ENDPOINTS.ADQUIRE_CONTACT, payload);
    return { data };
};

export const getExportPdf = async daysAgo => {
    const api = configAxiosContactNetworkBlob();
    const { data } = await api.get(`${ENDPOINTS.EXPORT_ACQUIRED_CONTACTS}${daysAgo}`);
    return { data };
};
